// extracted by mini-css-extract-plugin
export default {"list":"style_list__HK6uI","item":"style_item__dSnrz","sorter":"style_sorter__Cxelo"};